import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-back-link',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './back-link.ui-component.html',
  styleUrls: ['./back-link.ui-component.scss'],
})
export class BackLinkUiComponent {
  @Input() url = '';
  @Input() text = 'Back';
}
